var map = {
	"./business_account-spotlight-en.png": 27253,
	"./business_account-spotlight-fi.png": 62347,
	"./oy-spotlight-en.png": 85259,
	"./oy-spotlight-fi.png": 20465,
	"./tlp-spotlight-en.png": 36825,
	"./tlp-spotlight-fi.png": 67831,
	"./ukkopro-spotlight-en.png": 81928,
	"./ukkopro-spotlight-fi.png": 2486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44667;